import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { PortfolioCashDetail } from '../../../Models/Models/PortfolioAnalysis/Cash/PortfolioCashDetail';
import { IJsonDate } from '../../../System/IJsonDate';

declare var IS_RUNNING_IN_APP_POOL;

export class PortfolioCashDetailsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyIds: Array<string>, asAt: IJsonDate): Promise<Array<PortfolioCashDetail>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/PortfolioAnalysis/Cashes/PortfolioCashDetails/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyIds: hierarchyIds, asAt: asAt }

    return AjaxWrapper.get<Array<PortfolioCashDetail>, any>(url, data);
  }
}

